<template>
  <div class="page">
    <div class="layout">
      <div class="page-box">
        <el-tabs v-model="activeName" @tab-click="handleClick" style="padding-left: 5px;">
          <el-tab-pane label="未完成的作業" name="first">
          </el-tab-pane>
<!--          <el-tab-pane label="已完成的作業" 增加红色提示数字 name="second">-->
<!--          </el-tab-pane>-->
          <!-- 已完成作业标签（带红色数字提示） -->
          <el-tab-pane  name="second">
            <span slot="label">已完成的作業
              <el-badge :value="badHomeworkCount" :max="99" class="item"></el-badge>
            </span>
          </el-tab-pane>
        </el-tabs>
        <div class="page-box-content">
          <div class="page-content-row">
            <div>
              <div class="search-text">作業編號</div>
              <el-input
                  v-model="formLabelAlign.numberLike"
                  placeholder="請輸入作業編號"
              ></el-input>
            </div>
            <div v-if="userInfoRoleRoleId ==siteAdminRoleId">
              <div class="search-text">分校</div>
              <el-select
                  v-model="formLabelAlign.branchSchoolsId" placeholder="全部"
              >
                <el-option
                    v-for="(item, index) in $store.getters.branchSchools"
                    :key="index"
                    :label="item.abbreviation"
                    :value="item.id"
                ></el-option>
              </el-select>
            </div>
            <div>
              <div class="search-text">年級</div>
              <el-select v-model="formLabelAlign.gradeId" placeholder="全部">
                <el-option
                    v-for="(item, index) in grades"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                ></el-option>
              </el-select>
            </div>
            <div>
              <div class="search-text">語言</div>
              <el-select v-model="formLabelAlign.lang" placeholder="全部">
                <el-option
                    v-for="item in languages"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div>
              <el-button size="mini" type="info" @click="onSearch" class="button-el-el">搜尋全部</el-button>
            </div>
            <div>
              <el-button size="mini" type="info" @click="onSearchMy" class="button-el-el">我創建的作業</el-button>
            </div>
          </div>
        </div>
        <el-table
            @sort-change="handleSortChange"
            :data="tableData"
            style="width: 100%"
        >
<!--          <el-table-column-->
<!--              prop="branchSchoolsAbbreviation"-->
<!--              label="分校"-->
<!--              align="center"-->
<!--              sortable="custom"-->
<!--          ></el-table-column>-->
          <el-table-column
              prop="gradeName"
              label="年級"
              align="center"
          >
            <template slot-scope="{row}">
              <span :style="{ color: activeName === 'second' && row.percentage < 60 ? '#ff0000' : '#606266' }">{{row.gradeName}}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="createdName"
              label="老師"
              align="center"
          >
            <template slot-scope="{row}">
              <span :style="{ color: activeName === 'second' && row.percentage < 60 ? '#ff0000' : '#606266' }">{{row.createdName}}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="studentName"
              label="學生账号"
              align="center"
          >
            <template slot-scope="{row}">
              <span :style="{ color: activeName === 'second' && row.percentage < 60 ? '#ff0000' : '#606266' }">{{row.userNo}}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="studentName"
              label="學生姓名"
              align="center"
          >
            <template slot-scope="{row}">
              <span :style="{ color: activeName === 'second' && row.percentage < 60 ? '#ff0000' : '#606266' }">{{row.studentName}}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="number"
              label="作業編號"
              align="center"
          >
            <template slot-scope="{row}">
              <span :style="{ color: activeName === 'second' && row.percentage < 60 ? '#ff0000' : '#606266' }">{{row.number}}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="startDate"
              label="開始日期"
              align="center"
          >
            <template slot-scope="{row}">
              <span :style="{ color: activeName === 'second' && row.percentage < 60 ? '#ff0000' : '#606266' }">{{row.startDate | formatDate}}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="completedAt"
              label="完成日期"
              align="center"
              v-if="activeName=='first'"
          >
            <template slot-scope="{row}">
              <span>{{row.completedAt?row.completedAt:row.nDay+'天未完成'}}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="progress"
              label="得分"
              align="center"
              v-if="activeName=='second'"
          >
            <template slot-scope="{row}">
              <span v-if="row.percentage >= 80" style="color: green">{{ row.progress }}</span>
              <span v-else-if="row.percentage >= 60" style="color: orange">{{ row.progress }}</span>
              <span v-else style="color: red">{{ row.progress }}</span>
            </template>
          </el-table-column>
<!--          <el-table-column-->
<!--              prop="lang"-->
<!--              label="語言"-->
<!--              align="center"-->
<!--          >-->
<!--            <template slot-scope="{row}">-->
<!--              <span>{{row.lang | language}}</span>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--          <el-table-column label="操作"  align="center">-->
<!--            <template slot-scope="{ row }">-->
<!--              <el-button type="text" size="medium" @click="onCopyButton(row.id)"-->
<!--              >已處理</el-button>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-link v-if="scope.row.answerResult && scope.row.answerResult.id && scope.row.answerResult.id !== 'undefined'"
                       type="primary"
                       @click="navigateToResult(scope.row)"
              >
                答題記錄
                <el-badge v-if="scope.row.homeworkAssignStudentState===0" is-dot class="item"></el-badge>
              </el-link>

            </template>
          </el-table-column>
        </el-table>
        <Pagination
            v-show="total > 0"
            :total="total"
            :page.sync="formLabelAlign._page"
            :limit.sync="formLabelAlign._limit"
            @pagination="getHomeworks"
        />
      </div>
    </div>

    <deleteDialog
      titleCh="您確定要刪除此作業嗎？"
      :centerDialogVisible="centerDialogVisible"
      @confirmFunction="confirmFunction"
      @onCancelButton="onCancelButton"
    ></deleteDialog>

    <div class="mask" v-if="examination_switch">
      <examination ref="examination" @closeLoading="loading_switch = false"></examination>
    </div>

    <loadingDialog :center-dialog-visible="loading_switch" loading-text="正在匯出。。。">正在匯出。。。</loadingDialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { payStatus } from "@/biz/static-data";
import {getStudentHomeworks,editHomeworkState,getCountBadHomework} from "@/api/homeworks";
import deleteDialog from "@/components/deleteDialog";
import examination from "./components/examination.vue";
import loadingDialog from "@/components/loadingDialog/index";
import {getGrades} from '@/api/grade'
export default {
  components: { deleteDialog, Pagination, examination, loadingDialog },
  data() {
    return {
      activeName: 'first',
      loadingMsg: '正在匯出。。。',
      badHomeworkCount: 0,
      itemId:0,
      total: 0,
      payStatus: [],
      orderId: null,
      dialogSlotVisible: false,
      centerDialogVisible: false,
      formLabelAlign: {
        numberLike: null,
        gradeId: null,
        branchSchoolsId:null,
        completedAt: 0,
        createdId:null,
        lang: null,
        orderBy: null,
        _page: 1,
        _limit: 50,
      },
      tableData: [],
      grades: [],

      examination_switch: false,
      loading_switch: false
    };
  },
  created() {
    this.payStatus = payStatus;
    this.formLabelAlign.createdId = this.$store.getters.adminUserInfo.userId;
    this.getHomeworks();
    this.getGrades();
  },
  methods: {
    navigateToResult(row) {
      editHomeworkState(row.homeworkAssignStudentId).then(()=>{
        const baseUrl = '/#/answer-record-detail';
        const queryParams = {
          type: 'library',
          topicId: row.answerResult.topicId,
          id: row.answerResult.objectId,
          gradeId: row.answerResult.gradeId,
          userNo: row.answerResult.userNo,
          startTime: row.answerResult.startTime,
          answerResultId: row.answerResult.id,
          questionListIds: row.answerResult.questionListIds,
          answerValues: row.answerResult.answerValues
        };
        const queryString = Object.entries(queryParams)
            .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
            .join('&');
        const fullUrl = `${baseUrl}?${queryString}`;
        window.open(fullUrl, '_blank');
        this.getHomeworks();
      })
    },
    handleClick(tab, event) {
      console.log(tab, event);
      if(tab.name==='first'){
        this.formLabelAlign.completedAt=0;
      }else{
        this.formLabelAlign.completedAt=1;
      }
      this.formLabelAlign.createdId = this.$store.getters.adminUserInfo.userId;
      this.getHomeworks();
    },
    downloadPdf(title, id) {
      this.examination_switch = true
      this.$nextTick(() => {
        this.loading_switch = true
        let examination = this.$refs.examination
        examination.init(title, id)
      })
    },
    onDeleteButton(id){
       this.itemId = id
       this.centerDialogVisible = true
    },
    handleSortChange(column) {
      if (column.order === "descending") {
        this.formLabelAlign.orderBy = column.prop + " desc";
      } else if (column.order === "ascending") {
        this.formLabelAlign.orderBy = column.prop + " asc";
      } else {
        this.formLabelAlign.orderBy = null;
      }
      this.formLabelAlign._page = 1;
      this.getHomeworks();
    },
    onReset() {
      Object.keys(this.formLabelAlign).forEach((key) => {
        this.formLabelAlign[key] = null;
        if (key === "_page") {
          this.formLabelAlign[key] = 1;
        } else if (key === "_limit") {
          this.formLabelAlign[key] = 50;
        }

      })
      this.formLabelAlign.completedAt=0;
      this.getHomeworks();
    },
    onSearch() {
      this.formLabelAlign.createdId = null;
      this.getHomeworks();
    },
    onSearchMy() {
      this.formLabelAlign.createdId = this.$store.getters.adminUserInfo.userId;
      this.getHomeworks();
    },
    onCancelButton() {
      this.centerDialogVisible = false;
    },
    confirmFunction() {
     this.deleteHomeworks()
    },
    onCopyButton(id) {
      let path = `/job/${id}/copy`;
      this.resolveRouter(path)
    },
    onEditButton(id) {
      let path = `/job/${id}/edit`;
      this.resolveRouter(path)
    },
    onDetailButton(id) {
      let path = `/job/${id}`;
      this.resolveRouter(path)
    },
    onAlterButton(id) {
      this.orderId = id;
      this.centerDialogVisible = true;
    },
    getGrades(){
      getGrades().then((v) => {
        this.grades = v.data;
      });
    },
    getHomeworks() {
      this.getCountBadHomework();
      let formLabelAlign = {
        numberLike: this.formLabelAlign.numberLike,
        gradeId: this.formLabelAlign.gradeId,
        createdId: this.formLabelAlign.createdId,
        completedAt: this.formLabelAlign.completedAt,
        branchSchoolsId: this.formLabelAlign.branchSchoolsId,
        lang: this.formLabelAlign.lang,
        orderBy: this.formLabelAlign.orderBy,
        _page: this.formLabelAlign._page - 1,
        _limit: this.formLabelAlign._limit,
      };
      getStudentHomeworks(formLabelAlign).then((v) => {
        this.tableData = v.data;
        this.total = Number(v.headers["x-total-count"]);
      });
    },
    getCountBadHomework() {
      getCountBadHomework().then((v) => {
        this.badHomeworkCount = v.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  .layout {
    .el-row {
      padding: 20px;
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }

      .title {
        font-size: 30px;
      }
    }

    .el-button--text {
      color: #166ea5;
      font-size: 16px;
    }
  }
  .mask {
    position: absolute;
    bottom: 100%;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    background-color: skyblue;
  }
}
.page-box {
  background-color: #fff;
}
.button-el-el {
  width: 100%;
  margin-top: 23px;
}
.page-box-content{
  width: 100%;
  overflow-x: auto;
}
.page-content-row {
    display: grid;
    padding: 20px;
    grid-template-columns: repeat(8, 150px);
    grid-template-rows: repeat(1, 1fr);
    gap: 8px;
    align-items: end;
}
/* 圆形标签样式 */
.circle-tag {
  /* 基础圆形属性 */
  border-radius: 50% !important; /* 关键：圆角50% */
  width: 20px !important;        /* 固定宽度（根据需求调整） */
  height: 20px !important;       /* 宽高相等 */
  line-height: 20px !important;  /* 行高等于高度，垂直居中 */
  padding: 0 !important;         /* 清除默认内边距 */
  text-align: center;            /* 水平居中 */
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  font-size: 12px !important;    /* 字体大小适配 */
  min-width: 20px;               /* 防止小数字变形 */
}

/* 若数字多位（如10+），自适应宽高 */
.circle-tag:has(span) {
  width: auto !important;
  min-width: 20px;
  padding: 0 6px !important;
  border-radius: 12px !important; /* 椭圆更美观（可选） */
}
</style>